import React from 'react';
import ReactStars from 'react-rating-stars-component';
import { FaStarHalfAlt, FaStar, FaRegStar } from 'react-icons/fa';
import PropTypes from 'prop-types';
import theme from '@quiqupltd/qu-react-sdk/lib/styles/theme';

export const Rating = props => {
  return (
    <ReactStars
      {...props}
      size={50}
      emptyIcon={<FaRegStar />}
      halfIcon={<FaStarHalfAlt />}
      fullIcon={<FaStar />}
      activeColor={theme.sunflower500}
      color={theme.greyMedium}
    />
  );
};

Rating.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  edit: PropTypes.bool,
};

Rating.defaultProps = {
  value: 0,
  edit: true,
};



// WEBPACK FOOTER //
// ./src/app/order-card/completed/body/rate-delivery/rating/rating.js